//import { IProfileInfo } from '../models/IProfileInfo';
//import { IBasicSearchData } from '../models/IBasicSearchData';

export enum ActionTypes {
    SET_PROFILE_INFO = 'SET_PROFILE_INFO',
    LOGOUT_PROFILE = 'LOGOUT_PROFILE',
    REFRESH_MENU_DATA = 'REFRESH_MENU_DATA',
    SET_BASIC_SEARCH_DATA = 'SET_BASIC_SEARCH_DATA',
    SET_ADVANCED_SEARCH_DATA = 'SET_ADVANCED_SEARCH_DATA',
    RESET_SEARCH_DAY_SPAN = 'RESET_SEARCH_DAY_SPAN',
    SET_FULL_CLIENT_STATE = 'SET_FULL_CLIENT_STATE',
    SET_NEW_PAGE = 'SET_NEW_PAGE',
    SET_VISIT_INFO = 'SET_VISIT_INFO',
    SET_STATUS_BAR = 'SET_STATUS_BAR',
    SET_BASIC_SEARCH_DATA_AND_RESET_DAY_SPAN = 'SET_BASIC_SEARCH_DATA_AND_RESET_DAY_SPAN',
    SET_REGISTER_DATA = 'SET_REGISTER_DATA',
    SET_SEARCH_SELECTED_ITEM = 'SET_SEARCH_SELECTED_ITEM',
    SET_BASIC_SEARCH_DATA_AND_RESET_ADVANCED_CRITERIA = 'SET_BASIC_SEARCH_DATA_AND_RESET_ADVANCED_CRITERIA'
}

//export interface ISetProfileInfoAction { type: ActionTypes.SET_PROFILE_INFO, payload: IProfileInfo };
//export interface ILogoutProfile { type: ActionTypes.LOGOUT_PROFILE, payload: null };
//export interface ISetBasicSearchData { type: ActionTypes.SET_BASIC_SEARCH_DATA, payload: IBasicSearchData };

//export type Action = ISetProfileInfoAction | ILogoutProfile;


// WEBPACK FOOTER //
// ./src/constants/ActionTypes.tsx